module.exports = __webpack_public_path__ + "img/tree-desktop.14d383d.svg";